module.exports = __webpack_public_path__ + "ionicons.dd4781d1acc57ba4c480.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/fonts/ionicons.ttf?v=2.0.1
// module id = 580
// module chunks = 10